import { render, staticRenderFns, recyclableRender, components } from "./uni-load-more.vue?vue&type=template&id=4f1e3a94&"
var renderjs
import script from "./uni-load-more.vue?vue&type=script&lang=js&"
export * from "./uni-load-more.vue?vue&type=script&lang=js&"
import style0 from "./uni-load-more.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/uni-load-more.vue"
export default component.exports